import { Link } from "react-router-dom";
import { ASSETS } from "@/data/assets";

export default function Archive() {
  return (
    <main className="min-h-screen min-w-0 bg-[#090909] px-4 py-14 text-[#F5F0E8] sm:px-5 sm:py-16 md:py-24">
      <div className="mx-auto max-w-6xl">
        <div className="mb-10 flex flex-wrap items-end justify-between gap-6">
          <div>
            <p className="font-accent text-xs tracking-[0.42em] text-[#39E75F]">FOTOS ON THE GEAUX</p>
            <h1 className="mt-3 font-display text-5xl tracking-tighter md:text-7xl">ARCHIVE</h1>
            <p className="mt-4 max-w-2xl text-base leading-relaxed text-[#F5F0E8]/70 md:text-lg">
              Real Fotos, prints, and memories from past shoots and events.
            </p>
          </div>
          <Link
            to="/"
            className="rounded-full border border-white/15 px-5 py-3 font-accent text-xs tracking-[0.22em] text-[#F5F0E8] transition hover:border-[#39E75F] hover:text-[#39E75F]"
          >
            BACK TO POLE &amp; POLAROIDS
          </Link>
        </div>

        <section className="relative overflow-hidden rounded-[2rem] border border-white/10 bg-[#070707] p-4 shadow-[0_30px_90px_rgba(0,0,0,.45)] md:p-8">
          <div
            className="pointer-events-none absolute inset-0 opacity-40"
            style={{
              background:
                "radial-gradient(45% 60% at 12% 30%, rgba(227,38,54,.18), transparent), radial-gradient(45% 60% at 88% 70%, rgba(138,53,242,.18), transparent)",
            }}
          />
          <div className="relative grid min-w-0 items-center gap-8 lg:grid-cols-[minmax(0,1.15fr)_minmax(0,.85fr)] lg:gap-12">
            <figure className="float-img overflow-hidden rounded-2xl border border-white/10 bg-[#111]" style={{ "--float-duration": "7s" }}>
              <img
                src={ASSETS.realCollage}
                alt="Fotos on the Geaux archive collage"
                className="h-full w-full object-cover"
              />
            </figure>
            <div>
              <p className="font-accent text-xs tracking-[0.34em] text-[#39E75F]">ARCHIVED FOTOS</p>
              <h2 className="mt-4 font-display text-4xl leading-[.95] tracking-tighter md:text-6xl">
                REAL FOTOS.<br />REAL PRINTS.<br />REAL MEMORIES.
              </h2>
              <p className="mt-6 text-lg leading-relaxed text-[#F5F0E8]/75">
                Preserved as part of the Fotos on the Geaux archive and kept separate from the current Pole &amp; Polaroids campaign imagery.
              </p>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
}
